import {
  Transforms,
  Editor,
  Element as SlateElement
} from 'slate';

import * as basicEditorValueSerializer from 'basic-editor-value-serializer';

import application from 'application';

import types from '../../elements/types';

import HelptapEditor from '../';

export function getDefaultOptions() {

  return basicEditorValueSerializer.utilities.node.paragraph.getDefaultOptions();

}

export function buildNode(options = {}) {

  const node = {
    ...getDefaultOptions(),
    type: types.PAGE_AUTHOR,
    children: [{ text: '' }],
    width: '300px',
    marginRight: 'auto',
    height: '35px'
  };

  node.properties = {
    ...node.properties,
    ...options
  };

  return node;

}

export function insert(editor, options, editorOptions, targetNodePath, nextNodePath) {

  Transforms.insertNodes(editor, buildNode(options), { at: targetNodePath });

}

export function toggle(editor, options, editorOptions, targetNodePath, nextNodePath) {

  const nodeOptions = buildNode(options);

  HelptapEditor.setNodeOptions(editor, nodeOptions);

}

export function duplicate(editor, node, nodePath) {

  const clonedNode = HelptapEditor.cloneNode(node);

  HelptapEditor.insertNode(editor, clonedNode, nodePath);

}

export function update(editor) {

  const iterator = Editor.nodes(editor, {
    at: [], // Search the entire document
    match: n =>
      SlateElement.isElement(n) && n.type === types.PAGE_AUTHOR
  });

  const entries = Array.from(iterator);

  if (entries.length === 0) {
    return;
  }

  Editor.withoutNormalizing(editor, () => {

    const currentUser = application.getUser();
    const currentUserId = currentUser._id;
    const newAuthor = {
      _id: currentUserId,
      fullName: currentUser.fullName,
      profilePicture: currentUser.profilePicture
    };

    for (const [node, path] of entries) {

      const author = node.properties.author;

      if (author !== null && author._id === newAuthor._id) {
        continue;
      }

      Transforms.setNodes(
        editor, {
          properties: {
            ...node.properties,
            author: { ...newAuthor }
          }
        }, { at: path }
      );

    }

  });

}